(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gr-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class GrAnnc {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('.gr-annc__viewport');
      this.track = root.querySelector('[data-gr-annc-track]');
      if (!this.track) return;
      this.tpl = this.track.querySelector('.gr-annc__item').cloneNode(true);
      this.isTicker = this.track.dataset.ticker === 'true';
      if (!this.isTicker) return;

      this.build = this.build.bind(this);
      this.build();

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.build());
        this.ro.observe(this.viewport);
      } else {
        window.addEventListener('resize', this.build);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.build);
      }
    }

    build() {
      const vw = this.viewport.offsetWidth;
      if (!vw) return;
      const speed = parseFloat(this.track.dataset.speed) || 60;
      const dir = this.track.dataset.direction || 'left';

      this.track.classList.remove('is-animating');
      this.track.innerHTML = '';

      // Un grupo que cubra al menos el ancho del viewport
      const group = document.createElement('div');
      group.className = 'gr-annc__group';
      do {
        group.appendChild(this.tpl.cloneNode(true));
      } while (group.scrollWidth < vw && group.children.length < 400);

      // Dos grupos idénticos → loop sin costuras
      const group2 = group.cloneNode(true);
      this.track.appendChild(group);
      this.track.appendChild(group2);

      const groupWidth = group.scrollWidth;
      this.track.style.setProperty('--gr-annc-shift', groupWidth + 'px');
      this.track.style.setProperty('--gr-annc-dur', groupWidth / speed + 's');
      this.track.classList.toggle('is-reverse', dir === 'right');
      // fuerza reflow para reiniciar la animación limpia
      void this.track.offsetHeight;
      this.track.classList.add('is-animating');
    }
  }

  function grAnncInit(scope) {
    (scope || document).querySelectorAll('.gr-annc').forEach((el) => {
      if (el.dataset.grAnncReady) return;
      el.dataset.grAnncReady = '1';
      new GrAnnc(el);
    });
  }
  if (document.readyState !== 'loading') grAnncInit();
  else document.addEventListener('DOMContentLoaded', () => grAnncInit());
  document.addEventListener('shopify:section:load', (e) => grAnncInit(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gr-multicolumn"] && !Shopify.designMode) return;
  try {
    
  function grMcolEqualize(grid) {
    var tops = Array.prototype.slice.call(grid.querySelectorAll('.gr-mcol__top'));
    if (!tops.length) return;
    if (window.innerWidth < 750) {
      grid.style.removeProperty('--gr-mcol-top-h');
      return;
    }
    grid.style.setProperty('--gr-mcol-top-h', 'auto');
    var max = 0;
    tops.forEach(function (top) {
      max = Math.max(max, top.getBoundingClientRect().height);
    });
    grid.style.setProperty('--gr-mcol-top-h', max + 'px');
  }

  function grMcolInit(scope) {
    (scope || document).querySelectorAll('[data-gr-mcol]').forEach(function (grid) {
      grMcolEqualize(grid);
    });
  }

  var grMcolResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(grMcolResizeTimer);
    grMcolResizeTimer = setTimeout(function () { grMcolInit(); }, 150);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { grMcolInit(); });
  }

  if (document.readyState !== 'loading') grMcolInit();
  else document.addEventListener('DOMContentLoaded', function () { grMcolInit(); });
  document.addEventListener('shopify:section:load', function (e) { grMcolInit(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gr-product-grid"] && !Shopify.designMode) return;
  try {
    
  class GrPgrid {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-gr-pgrid-grid]');
      this.select = root.querySelector('[data-gr-pgrid-sort]');
      this.moreBtn = root.querySelector('[data-gr-pgrid-more]');
      this.visibleCount = parseInt(root.dataset.initialVisible, 10) || 30;
      this.expanded = false;

      if (!this.grid) return;

      const params = new URLSearchParams(window.location.search);
      const urlSort = params.get('gr_sort');
      if (this.select && urlSort && this.select.querySelector('option[value="' + CSS.escape(urlSort) + '"]')) {
        this.select.value = urlSort;
      }

      this.applyVisibility();
      this.decoratePagination();

      if (this.select) {
        this.select.addEventListener('change', () => {
          this.sort(this.select.value);
          this.applyVisibility();
          this.decoratePagination();
        });
      }

      if (this.moreBtn) {
        this.moreBtn.addEventListener('click', () => {
          this.expanded = true;
          this.applyVisibility();
        });
      }
    }

    getCards() {
      return Array.from(this.grid.querySelectorAll('[data-gr-pgrid-card]'));
    }

    sort(mode) {
      const cards = this.getCards();
      const collator = new Intl.Collator('es', { sensitivity: 'base' });

      const num = (card, attr) => parseFloat(card.dataset[attr]) || 0;

      cards.sort((a, b) => {
        switch (mode) {
          case 'title-asc':
            return collator.compare(a.dataset.title, b.dataset.title);
          case 'title-desc':
            return collator.compare(b.dataset.title, a.dataset.title);
          case 'price-asc':
            return num(a, 'price') - num(b, 'price');
          case 'price-desc':
            return num(b, 'price') - num(a, 'price');
          case 'date-desc':
            return num(b, 'date') - num(a, 'date');
          case 'date-asc':
            return num(a, 'date') - num(b, 'date');
          case 'discount-desc':
            return num(b, 'discount') - num(a, 'discount');
          case 'manual':
          default:
            return num(a, 'index') - num(b, 'index');
        }
      });

      const fragment = document.createDocumentFragment();
      cards.forEach((card) => fragment.appendChild(card));
      this.grid.appendChild(fragment);
    }

    applyVisibility() {
      const cards = this.getCards();
      const limit = this.expanded ? cards.length : this.visibleCount;
      cards.forEach((card, i) => {
        card.hidden = i >= limit;
      });
      if (this.moreBtn) {
        this.moreBtn.hidden = this.expanded;
      }
    }

    decoratePagination() {
      if (!this.select) return;
      const sortValue = this.select.value;
      this.root.querySelectorAll('.gr-pgrid__page-link[href]').forEach((link) => {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        if (sortValue && sortValue !== 'manual') {
          url.searchParams.set('gr_sort', sortValue);
        } else {
          url.searchParams.delete('gr_sort');
        }
        link.setAttribute('href', url.pathname + url.search);
      });
    }
  }

  window.grCountdownTarget = window.grCountdownTarget || function (days, hours, minutes) {
    var key = 'gr:countdown:target';
    try {
      var stored = sessionStorage.getItem(key);
      if (stored) return parseInt(stored, 10);
    } catch (e) {}
    var target = Date.now() + ((days * 1440) + (hours * 60) + minutes) * 60000;
    try { sessionStorage.setItem(key, String(target)); } catch (e) {}
    return target;
  };

  function grPgridInitCountdowns(root) {
    root.querySelectorAll('[data-gr-pgrid-countdown]').forEach((el) => {
      const isMock = el.dataset.mock === 'true';
      const target = isMock
        ? window.grCountdownTarget(parseInt(el.dataset.mockDays, 10) || 0, parseInt(el.dataset.mockHours, 10) || 0, parseInt(el.dataset.mockMinutes, 10) || 0)
        : new Date(el.dataset.end.replace(' ', 'T')).getTime();
      const dd = el.querySelector('[data-d]'), hh = el.querySelector('[data-h]'),
            mm = el.querySelector('[data-m]'), ss = el.querySelector('[data-s]');
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, target - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        if (dd) dd.textContent = pad(d);
        if (hh) hh.textContent = pad(h);
        if (mm) mm.textContent = pad(m);
        if (ss) ss.textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function grPgridInit(scope) {
    (scope || document).querySelectorAll('[data-gr-pgrid]').forEach((el) => {
      if (el.dataset.grPgridReady) return;
      el.dataset.grPgridReady = '1';
      new GrPgrid(el);
      grPgridInitCountdowns(el);
    });
  }
  if (document.readyState !== 'loading') grPgridInit();
  else document.addEventListener('DOMContentLoaded', () => grPgridInit());
  document.addEventListener('shopify:section:load', (e) => grPgridInit(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gr-product-main"] && !Shopify.designMode) return;
  try {
    
  class GrPmain {
    constructor(root) {
      this.root = root;
      this.productId = root.dataset.productId;
      this.track = root.querySelector('[data-gr-pmain-track]');
      this.slides = Array.from(root.querySelectorAll('[data-gr-pmain-slide]'));
      this.thumbs = Array.from(root.querySelectorAll('[data-gr-pmain-thumb]'));
      this.bundleUnits = 1;
      this.unitVariants = [this.readInitialVariant()];
      this.confirmedThisSession = false;
      /* Si llegas con ?variant= (p. ej. desde una tarjeta "otros colores"), ese color manda sobre la
         selección guardada de la sesión y la galería salta a su foto al cargar. */
      const urlVariant = new URLSearchParams(window.location.search).get('variant');
      if (!urlVariant) this.loadSessionState();
      this.initGallery();
      this.initInlinePicker();
      this.refreshUnitsFromPickerData();
      this.initBundle();
      this.initBuy();
      this.initTabs();
      this.initDrawerTriggers();
      this.initDrawerConfirmListener();
      this.initViewers();
      this.initTrustDate();
      this.syncUnit0ToPage();
      this.syncBundleUIFromState();
      if (urlVariant && this.unitVariants[0]) this.jumpGalleryToVariant(this.unitVariants[0].id, true);
    }

    readInitialVariant() {
      const el = document.querySelector('[data-gr-pmain-initial-variant]');
      if (!el) return { values: {}, id: null, price: null, compare: null, discount: 0, available: true };
      try {
        const d = JSON.parse(el.textContent);
        return { values: d.values || {}, id: d.id, price: d.price, compare: d.compare, discount: d.discount || 0, available: d.available };
      } catch (e) {
        return { values: {}, id: null, price: null, compare: null, discount: 0, available: true };
      }
    }

    /* ---------- Persistencia por sesión (por producto): la selección de talla/color
       (incluida cada unidad de un bundle) sobrevive a cerrar el drawer, cambiar de tier o
       recargar la página, mientras dure la pestaña. ---------- */
    sessionKey() {
      return 'gr:variant:' + this.productId;
    }

    loadSessionState() {
      if (!this.productId) return;
      try {
        const raw = sessionStorage.getItem(this.sessionKey());
        if (!raw) return;
        const saved = JSON.parse(raw);
        if (saved.unitVariants && saved.unitVariants.length) this.unitVariants = saved.unitVariants;
        if (saved.bundleUnits) this.bundleUnits = saved.bundleUnits;
        this.confirmedThisSession = !!saved.confirmed;
      } catch (e) {}
    }

    saveSessionState() {
      if (!this.productId) return;
      try {
        sessionStorage.setItem(this.sessionKey(), JSON.stringify({
          unitVariants: this.unitVariants,
          bundleUnits: this.bundleUnits,
          confirmed: this.confirmedThisSession,
        }));
      } catch (e) {}
    }

    /* ---------- Selector inline: chips directamente en la página (sin drawer) para elegir la
       variante de 1 unidad. Reutiliza los mismos datos que el drawer (data-gr-vdrawer-data,
       renderizado una vez globalmente en layout/theme.liquid) para resolver variant_id en
       cliente sin duplicar el JSON de variantes. El drawer sigue existiendo para el bundle
       (N>1 unidades independientes) y la calculadora de tallas. ---------- */
    initInlinePicker() {
      this.pickerHost = this.root.querySelector('[data-gr-pmain-picker]');
      if (!this.pickerHost) return;
      const dataEl = document.querySelector('[data-gr-vdrawer-data]');
      if (!dataEl) return;
      try {
        this.pickerData = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.pickerData = null;
        return;
      }
      this.pickerVariantMap = {};
      (this.pickerData.variants || []).forEach((v) => {
        this.pickerVariantMap[v.options.join('///')] = v;
      });

      this.pickerHost.addEventListener('click', (e) => {
        const chip = e.target.closest ? e.target.closest('[data-gr-vvalue]') : null;
        if (!chip || chip.disabled) return;
        const group = chip.closest('[data-gr-voption]');
        if (!group) return;
        const values = Object.assign({}, this.unitVariants[0].values);
        values[group.dataset.grVoption] = chip.dataset.grVvalue;
        const v = this.resolvePickerVariant(values);
        this.unitVariants[0] = {
          values: values,
          id: v ? v.id : null,
          price: v ? v.price : null,
          compare: v ? v.compare : null,
          discount: v ? (v.discount || 0) : 0,
          available: v ? v.available : false,
        };
        this.confirmedThisSession = true;
        this.saveSessionState();
        this.syncUnit0ToPage();
        this.jumpGalleryToVariant(this.unitVariants[0].id);
      });

      this.syncInlinePicker();
    }

    resolvePickerVariant(values) {
      const variants = (this.pickerData && this.pickerData.variants) || [];
      if (variants.length === 1) return variants[0];
      const names = (this.pickerData && this.pickerData.optionNames) || [];
      const key = names.map((n) => (values[n] != null ? values[n] : '')).join('///');
      return this.pickerVariantMap[key] || null;
    }

    /* ---------- sessionStorage solo debe recordar la TALLA/COLOR elegidos (values), nunca el
       precio/compare/descuento de aquel momento: si el comerciante cambia el precio de
       comparación entre visitas, una unidad restaurada desde una sesión antigua debe recalcular
       sus números contra los datos frescos de ESTA carga (this.pickerData), no repetir los
       guardados. Sin esto, un precio/descuento cacheado podía pisar al recién renderizado por el
       servidor. ---------- */
    refreshUnitsFromPickerData() {
      if (!this.pickerData) return;
      this.unitVariants = this.unitVariants.map((u) => {
        const v = this.resolvePickerVariant(u.values || {});
        if (!v) return u;
        return {
          values: u.values,
          id: v.id,
          price: v.price,
          compare: v.compare,
          discount: v.discount || 0,
          available: v.available,
        };
      });
    }

    isPickerValueAvailable(baseValues, optionName, value) {
      const names = (this.pickerData && this.pickerData.optionNames) || [];
      const variants = (this.pickerData && this.pickerData.variants) || [];
      const test = Object.assign({}, baseValues);
      test[optionName] = value;
      const complete = names.every((n) => !!test[n]);
      if (complete) {
        const v = this.resolvePickerVariant(test);
        return !!(v && v.available);
      }
      return variants.some((v) => v.available && names.every((n, idx) => !test[n] || v.options[idx] === test[n]));
    }

    syncInlinePicker() {
      if (!this.pickerHost) return;
      const values = this.unitVariants[0].values || {};
      this.pickerHost.querySelectorAll('[data-gr-voption]').forEach((group) => {
        const name = group.dataset.grVoption;
        const selectedSpan = group.querySelector('[data-gr-vselected]');
        group.querySelectorAll('[data-gr-vvalue]').forEach((chip) => {
          const val = chip.dataset.grVvalue;
          const avail = this.isPickerValueAvailable(values, name, val);
          chip.classList.toggle('is-unavailable', !avail);
          chip.disabled = !avail;
          chip.classList.toggle('is-active', values[name] === val);
        });
        if (selectedSpan) selectedSpan.textContent = values[name] || '';
      });
    }

    openDrawer(view, opts) {
      opts = opts || {};
      const base = this.unitVariants[0] || { values: {} };
      const prefill = this.unitVariants.slice(0, this.bundleUnits).map((u) => ({ optionValues: u.values }));
      while (prefill.length < this.bundleUnits) prefill.push({ optionValues: Object.assign({}, base.values) });
      document.dispatchEvent(new CustomEvent('gr:openVariantDrawer', {
        detail: {
          view: view,
          mode: opts.mode || 'edit',
          unitsCount: this.bundleUnits,
          prefill: prefill,
          message: opts.message,
          addLabel: opts.addLabel,
          buyNowLabel: opts.buyNowLabel,
        }
      }));
    }

    current() {
      if (!this.track || this.track.clientWidth === 0) return 0;
      const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      return Math.max(0, Math.min(this.slides.length - 1, i));
    }

    initGallery() {
      if (!this.track) return;
      this.thumbs.forEach((t) => t.addEventListener('click', () => {
        this.goToSlideIndex(parseInt(t.dataset.index, 10) || 0);
      }));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._scrollTimer);
        this._scrollTimer = setTimeout(() => this.syncThumbs(), 80);
      }, { passive: true });
    }

    goToSlideIndex(i, instant) {
      if (!this.track || i < 0 || i >= this.slides.length) return;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    }

    /* Al elegir color (chips inline o drawer), salta la galería a la foto de esa variante,
       si tiene una foto propia asignada en Shopify (variant.featured_media -> mediaId). */
    jumpGalleryToVariant(variantId, instant) {
      if (!this.track || !variantId || !this.pickerData) return;
      const variant = (this.pickerData.variants || []).find((v) => v.id === variantId);
      if (!variant || !variant.mediaId) return;
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(variant.mediaId));
      if (i === -1) return;
      this.goToSlideIndex(i, instant);
    }

    syncThumbs() {
      const i = this.current();
      this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    }

    initBundle() {
      const opts = Array.from(this.root.querySelectorAll('[data-gr-pmain-bundle-opt]'));
      if (!opts.length) return;
      opts.forEach((btn) => btn.addEventListener('click', () => {
        const qty = parseInt(btn.dataset.qty, 10) || 1;
        opts.forEach((b) => b.classList.toggle('is-active', b === btn));
        this.bundleUnits = qty;
        this.saveSessionState();
        this.syncBundleSummaryToPage();
        // tier 1 no necesita drawer (misma unidad ya elegida); tier 2/3 SIEMPRE abre el
        // drawer con N selectores independientes — comprar 2+ implica revisar cada talla.
        if (qty > 1) {
          const atc = this.root.querySelector('[data-gr-pmain-atc]');
          this.openDrawer('selector', {
            mode: 'buy',
            addLabel: atc ? (atc.dataset.atcLabel || atc.textContent) : undefined,
          });
        }
      }));
    }

    initBuy() {
      const form = this.root.querySelector('.gr-pmain__buy-form');
      if (!form) return;
      const atc = this.root.querySelector('[data-gr-pmain-atc]');

      // Todo el alta va siempre por AJAX (nunca el submit nativo con JS activo): así "Añadir a la
      // cesta" abre el cart drawer sin recargar. La selección de talla/color ya es visible e
      // interactiva en la propia página (chips inline), así que no hace falta ninguna "puerta"
      // salvo en bundle (N>1), que sigue necesitando revisar cada unidad por separado en el drawer.
      form.addEventListener('submit', (e) => {
        e.preventDefault();

        if (this.bundleUnits > 1) {
          this.openDrawer('selector', {
            mode: 'buy',
            addLabel: atc ? (atc.dataset.atcLabel || atc.textContent) : undefined,
          });
          return;
        }

        const u = this.unitVariants[0];
        if (!u || !u.id || !window.GrCart) return;
        window.GrCart.addItems([{ id: u.id, quantity: 1 }]).then((res) => {
          if (!res.ok) return;
          document.dispatchEvent(new CustomEvent('gr:openCartDrawer'));
        });
      });
    }

    initDrawerConfirmListener() {
      document.addEventListener('gr:variantDrawerConfirmed', (e) => {
        const detail = e.detail || {};
        if (!detail.units || !detail.units.length) return;

        this.unitVariants = detail.units.map((u) => ({
          values: u.values, id: u.id, price: u.price, compare: u.compare, discount: u.discount || 0, available: u.available,
        }));

        if (detail.complete) this.confirmedThisSession = true;

        if (detail.addedToCart) {
          // el bundle ya se añadió al carrito: la unidad 1 pasa a ser el estado "actual" de
          // la página y el selector de tier vuelve a 1 unidad (evita doble-alta accidental).
          this.bundleUnits = 1;
          this.unitVariants = [this.unitVariants[0]];
          const opts = Array.from(this.root.querySelectorAll('[data-gr-pmain-bundle-opt]'));
          opts.forEach((b) => b.classList.toggle('is-active', b.dataset.qty === '1'));
        }

        this.saveSessionState();
        this.syncUnit0ToPage();
        this.jumpGalleryToVariant(this.unitVariants[0] && this.unitVariants[0].id);
        this.syncBundleSummaryToPage();
      });
    }

    syncUnit0ToPage() {
      const u = this.unitVariants[0];
      if (!u) return;

      if (u.id) {
        const priceCurrent = this.root.querySelector('[data-gr-pmain-price-current]');
        const priceCompare = this.root.querySelector('[data-gr-pmain-price-compare]');
        const priceDiscount = this.root.querySelector('[data-gr-pmain-price-discount]');
        if (priceCurrent && u.price) priceCurrent.textContent = u.price;
        if (priceCompare) {
          if (u.compare) { priceCompare.textContent = u.compare; priceCompare.hidden = false; }
          else { priceCompare.hidden = true; priceCompare.textContent = ''; }
        }
        if (priceDiscount) {
          if (u.compare && u.discount > 0) { priceDiscount.textContent = u.discount + '%'; priceDiscount.hidden = false; }
          else { priceDiscount.hidden = true; priceDiscount.textContent = ''; }
        }
        const idInput = this.root.querySelector('[data-gr-pmain-id-input]');
        if (idInput) idInput.value = u.id;
      }

      const buyWrap = this.root.querySelector('.gr-pmain__buy');
      const forceSold = buyWrap && buyWrap.dataset.forceSold === 'true';
      const productSoldOut = buyWrap && buyWrap.dataset.productSoldOut === 'true';
      const sold = forceSold || productSoldOut || !u.available;
      const atc = this.root.querySelector('[data-gr-pmain-atc]');
      if (atc) {
        atc.disabled = sold;
        atc.textContent = sold ? (atc.dataset.soldLabel || atc.textContent) : (atc.dataset.atcLabel || atc.textContent);
      }

      const variantSoldEl = this.root.querySelector('[data-gr-pmain-variant-soldout]');
      if (variantSoldEl) variantSoldEl.hidden = productSoldOut || u.available;

      const badge = this.root.querySelector('[data-gr-pmain-badge]');
      if (badge) {
        if (u.compare && u.discount > 0 && !sold) { badge.textContent = u.discount + '% Descuento'; badge.hidden = false; }
        else { badge.hidden = true; }
      }

      this.syncInlinePicker();
    }

    /* ---------- "X personas viendo": oscila +/- swing sobre la base cada `interval` segundos,
       sin bajar nunca de 2 (evita que el número parezca falso al tocar 0/1). ---------- */
    initViewers() {
      const el = this.root.querySelector('[data-gr-pmain-viewers]');
      if (!el) return;
      const base = parseInt(el.dataset.base, 10) || 0;
      const swing = parseInt(el.dataset.swing, 10) || 5;
      const intervalSec = parseInt(el.dataset.interval, 10) || 6;
      const template = el.dataset.template || '[n] personas están viendo este producto';
      const textEl = el.querySelector('[data-gr-pmain-viewers-text]');
      if (!textEl || base <= 0) return;
      setInterval(() => {
        const min = Math.max(2, base - swing);
        const max = base + swing;
        const n = Math.floor(Math.random() * (max - min + 1)) + min;
        textEl.textContent = template.replace('[n]', n);
      }, intervalSec * 1000);
    }

    /* ---------- Fecha de entrega estimada: recalculada en cliente porque Shopify cachea el HTML
       y la fecha renderizada en el servidor se quedaría fija en el día de esa carga. ---------- */
    initTrustDate() {
      const el = this.root.querySelector('[data-gr-pmain-trust-date]');
      if (!el) return;
      const days = parseInt(el.dataset.days, 10) || 7;
      const template = el.dataset.template || 'Entrega estimada: [fecha]';
      const textEl = el.querySelector('[data-gr-pmain-trust-text]');
      if (!textEl) return;
      const target = new Date();
      target.setDate(target.getDate() + days);
      let text;
      try {
        text = target.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      } catch (e) {
        return;
      }
      text = text.charAt(0).toUpperCase() + text.slice(1);
      textEl.textContent = template.replace('[fecha]', text);
    }

    /* ---------- Resumen de opciones: fila única (1 unidad) o lista "Unidad N: ..." (bundle) ---------- */
    syncBundleUIFromState() {
      const opts = Array.from(this.root.querySelectorAll('[data-gr-pmain-bundle-opt]'));
      opts.forEach((b) => b.classList.toggle('is-active', parseInt(b.dataset.qty, 10) === this.bundleUnits));
      this.syncBundleSummaryToPage();
    }

    syncBundleSummaryToPage() {
      const single = this.root.querySelector('[data-gr-pmain-variants-single]');
      const multi = this.root.querySelector('[data-gr-pmain-variants-multi]');
      if (!single || !multi) return;

      if (this.bundleUnits <= 1) {
        single.hidden = false;
        multi.hidden = true;
        multi.innerHTML = '';
        return;
      }

      single.hidden = true;
      multi.hidden = false;
      multi.innerHTML = this.unitVariants.slice(0, this.bundleUnits).map((u, i) => {
        const summary = Object.values(u.values || {}).filter(Boolean).join(' / ') || '—';
        return (
          '<div class="gr-pmain__variant-row">' +
            '<span class="gr-pmain__variant-name">Unidad ' + (i + 1) + '</span>' +
            '<span class="gr-pmain__variant-value">' +
              '<b>' + summary + '</b>' +
              '<button type="button" class="gr-pmain__variant-change" data-gr-pmain-unit-edit="' + i + '">' +
                (this.root.dataset.changeLabel || 'Cambiar') +
              '</button>' +
            '</span>' +
          '</div>'
        );
      }).join('');

      Array.from(multi.querySelectorAll('[data-gr-pmain-unit-edit]')).forEach((btn) => {
        btn.addEventListener('click', () => {
          const atc = this.root.querySelector('[data-gr-pmain-atc]');
          this.openDrawer('selector', {
            mode: 'buy',
            addLabel: atc ? (atc.dataset.atcLabel || atc.textContent) : undefined,
          });
        });
      });
    }

    initTabs() {
      this.root.querySelectorAll('[data-gr-pmain-tabs]').forEach((tabs) => {
        const btns = Array.from(tabs.querySelectorAll('[data-gr-pmain-tab]'));
        const panels = Array.from(tabs.querySelectorAll('[data-gr-pmain-panel]'));
        btns.forEach((b) => b.addEventListener('click', () => {
          btns.forEach((x) => x.classList.toggle('is-active', x === b));
          panels.forEach((p) => p.classList.toggle('is-active', p.dataset.tab === b.dataset.tab));
        }));
      });
    }

    initDrawerTriggers() {
      this.root.querySelectorAll('[data-gr-pmain-open-drawer]').forEach((btn) => {
        btn.addEventListener('click', () => this.openDrawer(btn.dataset.view || 'selector', { mode: 'edit' }));
      });
    }
  }

  window.grCountdownTarget = window.grCountdownTarget || function (days, hours, minutes) {
    var key = 'gr:countdown:target';
    try {
      var stored = sessionStorage.getItem(key);
      if (stored) return parseInt(stored, 10);
    } catch (e) {}
    var target = Date.now() + ((days * 1440) + (hours * 60) + minutes) * 60000;
    try { sessionStorage.setItem(key, String(target)); } catch (e) {}
    return target;
  };

  function grPmainInitCountdowns(root) {
    root.querySelectorAll('[data-gr-pmain-countdown]').forEach((el) => {
      const isMock = el.dataset.mock === 'true';
      const target = isMock
        ? window.grCountdownTarget(parseInt(el.dataset.mockDays, 10) || 0, parseInt(el.dataset.mockHours, 10) || 0, parseInt(el.dataset.mockMinutes, 10) || 0)
        : new Date(el.dataset.end.replace(' ', 'T')).getTime();
      const dd = el.querySelector('[data-d]'), hh = el.querySelector('[data-h]'),
            mm = el.querySelector('[data-m]'), ss = el.querySelector('[data-s]');
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, target - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        if (dd) dd.textContent = pad(d);
        if (hh) hh.textContent = pad(h);
        if (mm) mm.textContent = pad(m);
        if (ss) ss.textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function grPmainInit(scope) {
    (scope || document).querySelectorAll('[data-gr-pmain]').forEach((el) => {
      if (el.dataset.grPmainReady) return;
      el.dataset.grPmainReady = '1';
      new GrPmain(el);
      grPmainInitCountdowns(el);
    });
  }
  if (document.readyState !== 'loading') grPmainInit();
  else document.addEventListener('DOMContentLoaded', () => grPmainInit());
  document.addEventListener('shopify:section:load', (e) => grPmainInit(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gr-product-slider"] && !Shopify.designMode) return;
  try {
    
  /* Arrastre con ratón en carruseles (en táctil sigue el scroll nativo). Compartido por gr-product-slider
     y gr-video-slider: cada archivo lo declara con "||" para que valga el primero que se cargue. */
  window.grDragScroll = window.grDragScroll || function (track, opts) {
    opts = opts || {};
    var down = false, moved = false, suppress = false, id = null, startX = 0, startLeft = 0, THRESH = 6;

    function refresh() { track.classList.toggle('is-draggable', track.scrollWidth > track.clientWidth + 1); }
    refresh();
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(track);
    else window.addEventListener('resize', refresh);

    function leftOf(card) {
      return card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }
    function nearest(pos) {
      var cards = opts.cards || [], best = 0, bestD = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(leftOf(cards[i]) - pos);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('selectstart', function (e) { if (down) e.preventDefault(); });
    track.addEventListener('click', function (e) {
      if (suppress) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !track.classList.contains('is-draggable')) return;
      down = true; moved = false; id = e.pointerId; startX = e.clientX; startLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== id) return;
      var dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < THRESH) return;
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(id); } catch (err) {}
        if (opts.onStart) opts.onStart();
      }
      track.scrollLeft = startLeft - dx;
    });
    function end(e) {
      if (!down || (e && e.pointerId !== id)) return;
      down = false;
      if (!moved) return;
      var dx = (e && e.clientX != null) ? e.clientX - startX : 0;
      var cards = opts.cards || [];
      var idx = nearest(track.scrollLeft);
      if (idx === nearest(startLeft) && Math.abs(dx) > 40) idx = Math.max(0, Math.min(cards.length - 1, idx + (dx < 0 ? 1 : -1)));
      var max = track.scrollWidth - track.clientWidth;
      var target = cards.length ? Math.min(max, leftOf(cards[idx])) : track.scrollLeft;
      track.classList.remove('is-dragging');
      track.scrollTo({ left: target, behavior: 'smooth' });
      suppress = true;
      setTimeout(function () { suppress = false; }, 0);
      moved = false;
      if (opts.onEnd) opts.onEnd();
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
  };

  class GrPslider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-gr-pslider-track]');
      this.cards = Array.from(root.querySelectorAll('[data-gr-pslider-card]'));
      this.fill = root.querySelector('[data-gr-pslider-fill]');
      this.speed = parseFloat(root.dataset.autoplaySpeed) || 6;
      this.pauseOnHover = root.dataset.pauseOnHover === 'true';

      if (!this.track || this.cards.length < 2) return;

      const nav = root.querySelector('[data-gr-pslider-nav]');
      const syncNav = () => {
        if (nav) nav.style.display = this.track.scrollWidth > this.track.clientWidth + 1 ? '' : 'none';
      };
      syncNav();
      if (window.ResizeObserver) new ResizeObserver(syncNav).observe(this.track);
      else window.addEventListener('resize', syncNav);

      window.grDragScroll(this.track, {
        cards: this.cards,
        onStart: () => this.pause(),
        onEnd: () => { if (!this.pauseOnHover) this.play(); }
      });

      root.querySelector('[data-gr-pslider-prev]')?.addEventListener('click', () => this.step(-1));
      root.querySelector('[data-gr-pslider-next]')?.addEventListener('click', () => this.step(1));

      if (this.pauseOnHover) {
        root.addEventListener('mouseenter', () => this.pause());
        root.addEventListener('mouseleave', () => this.play());
      }

      this.track.addEventListener('scroll', () => {
        clearTimeout(this._scrollEndTimer);
        this._scrollEndTimer = setTimeout(() => this.restartFill(), 120);
      }, { passive: true });

      this.play();
    }

    step(dir) {
      const card = this.cards[0];
      const delta = (card.getBoundingClientRect().width + 2) * dir;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atEnd = this.track.scrollLeft >= maxScroll - 2;
      const atStart = this.track.scrollLeft <= 2;

      if (dir > 0 && atEnd) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dir < 0 && atStart) {
        this.track.scrollTo({ left: maxScroll, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: delta, behavior: 'smooth' });
      }
    }

    play() {
      this.pause();
      this.restartFill();
      this.timer = setInterval(() => this.step(1), this.speed * 1000);
    }

    pause() {
      if (this.timer) clearInterval(this.timer);
    }

    restartFill() {
      if (!this.fill) return;
      this.fill.classList.remove('is-animating');
      this.fill.style.transitionDuration = '0s';
      void this.fill.offsetHeight;
      this.fill.style.transitionDuration = this.speed + 's';
      this.fill.classList.add('is-animating');
    }
  }

  window.grCountdownTarget = window.grCountdownTarget || function (days, hours, minutes) {
    var key = 'gr:countdown:target';
    try {
      var stored = sessionStorage.getItem(key);
      if (stored) return parseInt(stored, 10);
    } catch (e) {}
    var target = Date.now() + ((days * 1440) + (hours * 60) + minutes) * 60000;
    try { sessionStorage.setItem(key, String(target)); } catch (e) {}
    return target;
  };

  function grPsliderInitCountdowns(root) {
    root.querySelectorAll('[data-gr-pslider-countdown]').forEach((el) => {
      const isMock = el.dataset.mock === 'true';
      const target = isMock
        ? window.grCountdownTarget(parseInt(el.dataset.mockDays, 10) || 0, parseInt(el.dataset.mockHours, 10) || 0, parseInt(el.dataset.mockMinutes, 10) || 0)
        : new Date(el.dataset.end.replace(' ', 'T')).getTime();
      const dd = el.querySelector('[data-d]'), hh = el.querySelector('[data-h]'),
            mm = el.querySelector('[data-m]'), ss = el.querySelector('[data-s]');
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, target - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        if (dd) dd.textContent = pad(d);
        if (hh) hh.textContent = pad(h);
        if (mm) mm.textContent = pad(m);
        if (ss) ss.textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function grPsliderInit(scope) {
    (scope || document).querySelectorAll('[data-gr-pslider]').forEach((el) => {
      if (el.dataset.grPsliderReady) return;
      el.dataset.grPsliderReady = '1';
      new GrPslider(el);
      grPsliderInitCountdowns(el);
    });
  }
  if (document.readyState !== 'loading') grPsliderInit();
  else document.addEventListener('DOMContentLoaded', () => grPsliderInit());
  document.addEventListener('shopify:section:load', (e) => grPsliderInit(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gr-promo-slideshow"] && !Shopify.designMode) return;
  try {
    
  window.grCountdownTarget = window.grCountdownTarget || function (days, hours, minutes) {
    var key = 'gr:countdown:target';
    try {
      var stored = sessionStorage.getItem(key);
      if (stored) return parseInt(stored, 10);
    } catch (e) {}
    var target = Date.now() + ((days * 1440) + (hours * 60) + minutes) * 60000;
    try { sessionStorage.setItem(key, String(target)); } catch (e) {}
    return target;
  };

  class GrSlideshow {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-gr-slideshow-slide]'));
      this.fill = root.querySelector('[data-gr-slideshow-fill]');
      this.speed = parseFloat(root.dataset.autoplaySpeed) || 6;
      this.index = 0;
      if (this.slides.length > 1) {
        root.querySelector('[data-gr-slideshow-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        root.querySelector('[data-gr-slideshow-next]')?.addEventListener('click', () => this.go(this.index + 1));
        root.addEventListener('mouseenter', () => this.pause());
        root.addEventListener('mouseleave', () => this.play());
        this.play();
      }
      this.initCountdowns();
    }

    go(i) {
      const n = this.slides.length;
      this.slides[this.index].classList.remove('is-active');
      this.index = ((i % n) + n) % n;
      this.slides[this.index].classList.add('is-active');
      this.restartFill();
      this.play();
    }

    play() {
      this.pause();
      this.restartFill();
      this.timer = setInterval(() => this.go(this.index + 1), this.speed * 1000);
    }

    pause() {
      if (this.timer) clearInterval(this.timer);
    }

    restartFill() {
      if (!this.fill) return;
      this.fill.classList.remove('is-animating');
      this.fill.style.transitionDuration = '0s';
      void this.fill.offsetHeight;
      this.fill.style.transitionDuration = this.speed + 's';
      this.fill.classList.add('is-animating');
    }

    initCountdowns() {
      this.root.querySelectorAll('[data-gr-slideshow-countdown]').forEach((el) => {
        const isMock = el.dataset.mock === 'true';
        const target = isMock
          ? window.grCountdownTarget(parseInt(el.dataset.mockDays, 10) || 0, parseInt(el.dataset.mockHours, 10) || 0, parseInt(el.dataset.mockMinutes, 10) || 0)
          : new Date(el.dataset.end.replace(' ', 'T')).getTime();
        const dd = el.querySelector('[data-d]'), hh = el.querySelector('[data-h]'),
              mm = el.querySelector('[data-m]'), ss = el.querySelector('[data-s]');
        const pad = (n) => String(n).padStart(2, '0');
        const tick = () => {
          let diff = Math.max(0, target - Date.now());
          const d = Math.floor(diff / 864e5); diff -= d * 864e5;
          const h = Math.floor(diff / 36e5); diff -= h * 36e5;
          const m = Math.floor(diff / 6e4); diff -= m * 6e4;
          const s = Math.floor(diff / 1e3);
          if (dd) dd.textContent = pad(d);
          if (hh) hh.textContent = pad(h);
          if (mm) mm.textContent = pad(m);
          if (ss) ss.textContent = pad(s);
        };
        tick();
        setInterval(tick, 1000);
      });
    }
  }

  function grSlideshowInit(scope) {
    (scope || document).querySelectorAll('[data-gr-slideshow]').forEach((el) => {
      if (el.dataset.grSlideshowReady) return;
      el.dataset.grSlideshowReady = '1';
      new GrSlideshow(el);
    });
  }
  if (document.readyState !== 'loading') grSlideshowInit();
  else document.addEventListener('DOMContentLoaded', () => grSlideshowInit());
  document.addEventListener('shopify:section:load', (e) => grSlideshowInit(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gr-video-slider"] && !Shopify.designMode) return;
  try {
    
  /* Arrastre con ratón en carruseles (en táctil sigue el scroll nativo). Compartido por gr-product-slider
     y gr-video-slider: cada archivo lo declara con "||" para que valga el primero que se cargue. */
  window.grDragScroll = window.grDragScroll || function (track, opts) {
    opts = opts || {};
    var down = false, moved = false, suppress = false, id = null, startX = 0, startLeft = 0, THRESH = 6;

    function refresh() { track.classList.toggle('is-draggable', track.scrollWidth > track.clientWidth + 1); }
    refresh();
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(track);
    else window.addEventListener('resize', refresh);

    function leftOf(card) {
      return card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }
    function nearest(pos) {
      var cards = opts.cards || [], best = 0, bestD = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(leftOf(cards[i]) - pos);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('selectstart', function (e) { if (down) e.preventDefault(); });
    track.addEventListener('click', function (e) {
      if (suppress) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !track.classList.contains('is-draggable')) return;
      down = true; moved = false; id = e.pointerId; startX = e.clientX; startLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== id) return;
      var dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < THRESH) return;
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(id); } catch (err) {}
        if (opts.onStart) opts.onStart();
      }
      track.scrollLeft = startLeft - dx;
    });
    function end(e) {
      if (!down || (e && e.pointerId !== id)) return;
      down = false;
      if (!moved) return;
      var dx = (e && e.clientX != null) ? e.clientX - startX : 0;
      var cards = opts.cards || [];
      var idx = nearest(track.scrollLeft);
      if (idx === nearest(startLeft) && Math.abs(dx) > 40) idx = Math.max(0, Math.min(cards.length - 1, idx + (dx < 0 ? 1 : -1)));
      var max = track.scrollWidth - track.clientWidth;
      var target = cards.length ? Math.min(max, leftOf(cards[idx])) : track.scrollLeft;
      track.classList.remove('is-dragging');
      track.scrollTo({ left: target, behavior: 'smooth' });
      suppress = true;
      setTimeout(function () { suppress = false; }, 0);
      moved = false;
      if (opts.onEnd) opts.onEnd();
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
  };

  class GrVslider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-gr-vslider-track]');
      this.cards = Array.from(root.querySelectorAll('[data-gr-vslider-card]'));
      this.fill = root.querySelector('[data-gr-vslider-fill]');
      this.activeIndex = -1;
      this.inView = false;

      if (!this.track || !this.cards.length) return;

      window.grDragScroll(this.track, { cards: this.cards });

      root.querySelector('[data-gr-vslider-prev]')?.addEventListener('click', () => this.step(-1));
      root.querySelector('[data-gr-vslider-next]')?.addEventListener('click', () => this.step(1));

      this.track.addEventListener(
        'scroll',
        () => {
          this.updateFill();
          clearTimeout(this._scrollEndTimer);
          this._scrollEndTimer = setTimeout(() => this.updateActiveFromScroll(), 120);
        },
        { passive: true }
      );

      this.cards.forEach((card) => this.bindCard(card));

      this.sectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.inView = entry.isIntersecting;
            if (this.inView) this.playActive();
            else this.pauseAll();
          });
        },
        { threshold: 0.4 }
      );
      this.sectionObserver.observe(root);

      this.updateFill();
      this.updateActiveFromScroll();
    }

    bindCard(card) {
      const video = card.querySelector('[data-gr-vslider-video], video');
      const playBtn = card.querySelector('[data-gr-vslider-playtoggle]');
      const muteBtn = card.querySelector('[data-gr-vslider-mutetoggle]');
      const atcBtn = card.querySelector('[data-gr-vslider-atc]');

      if (video) {
        playBtn?.addEventListener('click', () => {
          if (video.paused) video.play().catch(() => {});
          else video.pause();
        });
        video.addEventListener('play', () => card.classList.add('is-playing'));
        video.addEventListener('pause', () => card.classList.remove('is-playing'));

        muteBtn?.addEventListener('click', () => {
          video.muted = !video.muted;
          card.classList.toggle('is-muted', video.muted);
        });
      }

      atcBtn?.addEventListener('click', () => this.addToCart(atcBtn));
    }

    step(dir) {
      const card = this.cards[0];
      const delta = (card.getBoundingClientRect().width + 2) * dir;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const atEnd = this.track.scrollLeft >= maxScroll - 2;
      const atStart = this.track.scrollLeft <= 2;

      if (dir > 0 && atEnd) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (dir < 0 && atStart) {
        this.track.scrollTo({ left: maxScroll, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: delta, behavior: 'smooth' });
      }
    }

    updateFill() {
      if (!this.fill) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const fraction = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;
      this.fill.style.transform = `scaleX(${Math.min(1, Math.max(0, fraction))})`;
    }

    updateActiveFromScroll() {
      const trackRect = this.track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let closest = 0;
      let closestDist = Infinity;
      this.cards.forEach((card, i) => {
        const r = card.getBoundingClientRect();
        const dist = Math.abs(r.left + r.width / 2 - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      if (closest !== this.activeIndex) {
        this.activeIndex = closest;
        if (this.inView) this.playActive();
      }
    }

    playActive() {
      this.cards.forEach((card, i) => {
        const video = card.querySelector('video');
        if (!video) return;
        if (i === this.activeIndex) {
          video.muted = true;
          card.classList.add('is-muted');
          const playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(() => {});
        } else if (!video.paused) {
          video.pause();
          video.currentTime = 0;
          video.muted = true;
          card.classList.add('is-muted');
        }
      });
    }

    pauseAll() {
      this.cards.forEach((card) => {
        const video = card.querySelector('video');
        if (video && !video.paused) video.pause();
      });
    }

    addToCart(btn) {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }
      config.body = formData;

      fetch(window.routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error(response.description || response.message);
            return;
          }
          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gr-vslider',
            productVariantId: variantId,
            cartData: response,
          });
          cart.renderContents(response);
        })
        .catch((e) => console.error(e))
        .finally(() => {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-loading');
        });
    }
  }

  window.grCountdownTarget = window.grCountdownTarget || function (days, hours, minutes) {
    var key = 'gr:countdown:target';
    try {
      var stored = sessionStorage.getItem(key);
      if (stored) return parseInt(stored, 10);
    } catch (e) {}
    var target = Date.now() + ((days * 1440) + (hours * 60) + minutes) * 60000;
    try { sessionStorage.setItem(key, String(target)); } catch (e) {}
    return target;
  };

  function grVsliderInitCountdowns(root) {
    root.querySelectorAll('[data-gr-vslider-countdown]').forEach((el) => {
      const isMock = el.dataset.mock === 'true';
      const target = isMock
        ? window.grCountdownTarget(parseInt(el.dataset.mockDays, 10) || 0, parseInt(el.dataset.mockHours, 10) || 0, parseInt(el.dataset.mockMinutes, 10) || 0)
        : new Date(el.dataset.end.replace(' ', 'T')).getTime();
      const dd = el.querySelector('[data-d]'), hh = el.querySelector('[data-h]'),
            mm = el.querySelector('[data-m]'), ss = el.querySelector('[data-s]');
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, target - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        if (dd) dd.textContent = pad(d);
        if (hh) hh.textContent = pad(h);
        if (mm) mm.textContent = pad(m);
        if (ss) ss.textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function grVsliderInit(scope) {
    (scope || document).querySelectorAll('[data-gr-vslider]').forEach((el) => {
      if (el.dataset.grVsliderReady) return;
      el.dataset.grVsliderReady = '1';
      new GrVslider(el);
      grVsliderInitCountdowns(el);
    });
  }
  if (document.readyState !== 'loading') grVsliderInit();
  else document.addEventListener('DOMContentLoaded', () => grVsliderInit());
  document.addEventListener('shopify:section:load', (e) => grVsliderInit(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
